"use client";

export function ChartPlaceholder({ message }: { message: string }) {
  return (
    <div className="flex items-center justify-center h-[220px] bg-surface-light/5 rounded-lg">
      <p className="text-xs text-muted-foreground">{message}</p>
    </div>
  );
}
